import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Reveal } from '../hooks/useReveal';
import { SectionTitle } from './About';
import { assets } from '../mock';
import { Disc3 } from 'lucide-react';

const Music = () => {
  const { t } = useLanguage();
  return (
    <section id="music" className="section-pad bg-[#14120d]">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <SectionTitle eyebrow={t.music.eyebrow} title={t.music.title} subtitle={t.music.subtitle} />
        </Reveal>

        <div className="grid lg:grid-cols-2 gap-10 lg:gap-14 items-center mt-14">
          <Reveal>
            <div className="flex flex-wrap gap-3">
              {t.music.genres.map((g) => (
                <span
                  key={g}
                  className="inline-flex items-center gap-2 px-5 py-3 border border-[#e6b83f]/25 rounded-sm font-sans-el text-sm text-[#d8d2c4] hover:border-[#e6b83f]/60 hover:text-[#f5deA0] transition-colors"
                >
                  <Disc3 size={15} className="text-[#e6b83f]" /> {g}
                </span>
              ))}
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="rounded-md overflow-hidden border border-[#e6b83f]/20">
              <iframe
                title="LAJO Spotify"
                src={assets.spotifyPlaylist}
                width="100%"
                height="380"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Music;
